import RunningWithoutDriverRequester from '@cobliteam/api-lib/src/dashboard/faceId/RunningWithoutDriverRequester';
import { keepPreviousData, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { PageRunningWithoutDriverVehicles, RunningWithoutDriverVehiclesArgs, VehicleWithUnnamedClusters } from './types';

export const QUERY_KEY = 'RUNNING_WITHOUT_DRIVER_VEHICLES';

const requester = new RunningWithoutDriverRequester();

const useRunningWithoutDriverVehicles = (args: RunningWithoutDriverVehiclesArgs, options: Partial<UseQueryOptions<PageRunningWithoutDriverVehicles>> = {}) =>
  useQuery<PageRunningWithoutDriverVehicles>({
    queryKey: [QUERY_KEY, args.groupIds, args.page, args.size],
    queryFn: async () => {
      const { page, content } = await requester.getRunningWithoutDriverVehicles(args);
      // `vehicle` is nullable in the contract; rows without one can't be rendered, so drop them.
      return { page, content: content.filter((row): row is VehicleWithUnnamedClusters => row.vehicle != null) };
    },
    // Keep the previous page on screen while the next one loads, so pagination doesn't flash empty.
    placeholderData: keepPreviousData,
    ...options,
  });

export default useRunningWithoutDriverVehicles;
